// Mobile sticky add-to-cart bar. Lives inside the product form, so its submit button
// goes through <s-product-form> exactly like the main button. It reveals itself only
// once the main add-to-cart button has scrolled above the viewport.
class SStickyAddToCart extends HTMLElement {
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    const target = form?.querySelector('[data-main-add-to-cart]');
    this.#setVisible(false);
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('s-sticky-add-to-cart')) {
  customElements.define('s-sticky-add-to-cart', SStickyAddToCart);
}
